/* eslint no-multi-spaces: off */
import I18n from '~/i18n';
import countriesEnum from '~/enums/countriesEnum';
import fetchCorporatePartner from '~/utils/fetchCorporatePartner';
import findPartner from '~/utils/findPartner';
import fetchPartners from '~/utils/fetchPartners';

import { appName } from '../uri';

const trAttr = (attr) => I18n.t(`person.attributes.${attr}`);
const trExtra = (extra) => I18n.t(`person.extras.${extra}`);

export const reasonToUseOptions = {
  op_001: '1 - Sou mãe/pai e quero cuidar dos meus filhos',
  op_002: '2 - Quero cuidar de quem eu gosto',
  op_003: '3 - Sou filho e vou participar do app',
  op_004: '4 - Tenho mais de 60 anos e vou participar do app',
  op_005: '5 - Quero a Orientação Médica',
  op_006: '6 - Sou gestor e quero a Direção Inteligente na frota',
  op_007: '7 - Sou motorista de caminhão e vou participar do app',
  op_008: '8 - Tenho interesse no Botão de Pânico SOS',
  op_009: '9 - Outros',
  op_010: '10 - Sou colaborador / dependente de uma empresa',
};

export const packageOptions = {
  users: 'Adicional de Usuários',
  emergency: 'Botão de Pânico',
  driving: 'Direção Inteligente',
  doctor: `${appName} Médico`,
  doctor_all: 'Médico especialista',
  plan: 'Assinatura',
};

export const languagesOptions = {
  pt: 'Português',
  en: 'Inglês',
  es: 'Espanhol',
};

const equalOption = {
  yes: 'Sim',
  no: 'Não',
};

const platformOpt = {
  ios: 'iPhone',
  android: 'Android',
  unknown: 'Desconhecido',
};

const config = () => [
  { field: 'id', type: 'numeric', title: trAttr('id'), precision: 0 },
  { field: 'name', type: 'string', title: trAttr('name') },
  { field: 'email', type: 'string', title: trAttr('email') },
  { field: 'cell_phone', type: 'string', title: trAttr('cell_phone') },
  {
    field: 'phone_country_prefix',
    type: 'string',
    title: trAttr('phone_country_prefix'),
    hidden: true,
  },
  {
    field: 'partner_supplier_id',
    type: 'numeric',
    title: trAttr('partner_supplier_id'),
    precision: 0,
    includeThousandsSeparator: false,
    hidden: true,
  },
  {
    field: 'cns',
    type: 'number',
    title: trAttr('cns'),
    hidden: false,
  },
  {
    field: 'partner',
    type: 'string',
    explain: 'Este filtro busca os usuários que estão com parceiros vinculados',
    title: trAttr('partner_id'),
    hidden: true,
  },

  { field: 'created_at', type: 'datetime', title: trAttr('created_at') },
  { field: 'last_access', type: 'date', title: trAttr('last_access') },
  { field: 'expires_at', type: 'datetime', title: trAttr('expires_at') },
  {
    field: 'purchased_addon_id',
    type: 'string',
    title: trExtra('purchased_addon_id'),
    hidden: true,
  },
  {
    field: 'signature_enabled',
    type: 'boolean',
    title: trAttr('signature'),
    lookup: { active: 'Ativo', inactive: 'Inativo' },
    hidden: true,
  },
  {
    field: 'signature_first_date',
    type: 'datetime',
    title: trExtra('signature_first_date'),
    explain: 'Data da primeira transação aprovada pela loja',
    hidden: true,
  },
  {
    field: 'app_version',
    title: trAttr('app_version'),
    type: 'string',
    explain:
      'Busca pela versão instalada do aplicativo. Pode levar até 24h para atualizar essa informação do usuário.',
    hidden: true,
  },
  {
    field: 'last_sign_state',
    type: 'string',
    title: trExtra('last_sign_state'),
    explain: 'Status da última transação de assinatura',
    hidden: true,
  },
  {
    field: 'first_card_add',
    type: 'datetime',
    title: trExtra('first_card_add'),
    explain: `Data da primeira vez que o usuário adicionou o cartão na loja para compra o ${appName}`,
    hidden: true,
  },
  {
    field: 'reason_to_use',
    type: 'boolean',
    title: trAttr('reason_to_use'),
    lookup: reasonToUseOptions,
    hidden: true,
  },

  {
    field: 'actived_addon_type',
    type: 'boolean',
    title: trExtra('actived_addon_type'),
    explain:
      'Este filtro busca pelos usuários que estão com determinado adicional ativo em sua conta, indiferente se foi ele que comprou ou não.',
    lookup: packageOptions,
    hidden: true,
  },
  {
    field: 'purchased_addon_type',
    type: 'boolean',
    title: trExtra('purchased_addon_type'),
    explain:
      'Com este filtro é possível buscar os usuários que compraram determinado adicional e o adicional está ativo.',
    lookup: packageOptions,
    hidden: true,
  },
  {
    field: 'purchased_and_actived_addon_type',
    type: 'boolean',
    title: trExtra('purchased_and_actived_addon_type'),
    explain:
      'Com este filtro é possível identificar se o usuário já comprou alguma vez ou não determinado adicional, indiferente se o adicional está ativo ou não.',
    lookup: packageOptions,
    hidden: true,
  },
  {
    field: 'platform',
    type: 'string',
    title: trAttr('platform'),
    lookup: platformOpt,
    hidden: true,
  },
  {
    field: 'pilot',
    type: 'string',
    explain:
      'Este filtro busca os usuários na qual a assinatua foi liberada como piloto.',
    title: trExtra('pilot'),
    lookup: equalOption,
    hidden: true,
  },
  {
    field: 'users_child',
    type: 'string',
    explain:
      'Este filtro busca os usuários que participam de algum grupo como convidado.',
    title: trExtra('child'),
    lookup: equalOption,
    hidden: true,
  },
  {
    field: 'users_father',
    type: 'string',
    explain:
      'Este filtro busca os usuários que criaram pelo menos um grupo e este grupo possui algum outro convidado.',
    title: trExtra('father'),
    lookup: equalOption,
    hidden: true,
  },
  {
    field: 'created_group',
    type: 'string',
    explain: 'Este filtro busca os usuários que já criaram um grupo (ou não).',
    title: trExtra('created_group'),
    lookup: equalOption,
    hidden: true,
  },
  {
    field: 'free_period',
    type: 'string',
    explain:
      'Este filtro busca os usuários que estão no período de 3 dias (ou não)',
    title: trExtra('free_period'),
    lookup: equalOption,
    hidden: true,
  },
  {
    field: 'nationality',
    type: 'string',
    explain: 'Este filtro busca os usuário pelo país de sua nacionalidade',
    title: trAttr('nationality'),
    lookup: countriesEnum().objects('id', 'nationality'),
    hidden: true,
  },
  {
    field: 'doctor_interest',
    type: 'boolean',
    explain: 'Este filtro busca os usuários que tem interesse no pacote médico',
    title: trAttr('doctor_interest'),
    hidden: true,
  },
  {
    field: 'device_language',
    type: 'string',
    explain: 'Este filtro busca os usuários pela sua linguagem',
    title: trAttr('device_language'),
    lookup: languagesOptions,
    hidden: true,
  },
  {
    field: 'store_location',
    type: 'string',
    explain:
      'Este filtro busca os usuários na qual a loja de aplicativos está setada como brasileira ou não',
    title: trAttr('store_location'),
    lookup: {
      BR: 'Brasil',
      US: 'Estrangeiro',
    },
    hidden: true,
  },
  {
    field: 'partner_owner',
    type: 'string',
    explain: 'Este filtro busca os usuários que administradores de parceiros',
    title: trAttr('owner_partner'),
    hidden: true,
    asyncFetch: fetchPartners,
    asyncShow: findPartner,
  },
  {
    field: 'corporate_partner_id',
    type: 'async',
    explain:
      'Com este filtro é possível filtrar o usuários que pertencem ou não a uma empresa parceira.',
    title: trAttr('corporate_partner'),
    hidden: true,
    asyncFetch: fetchCorporatePartner,
    asyncShow: findPartner,
  },
];

export default config;
